import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "brokerageProvider",
  initialState: {
    addingBrokerageProvider: false,
    addedBrokerageProvider: false,
    brokerageProviders: [],
    brokerageCreateResp: {},
  },

  reducers: {
    // GET Request

    allBrokeragePaymentProviderSuccess: (brokerageProvider, action) => {
      brokerageProvider.brokerageProviders = action.payload.paymentDetails;
    },
    addingBrokerageProviderInitialize: (brokerageProvider, action) => {
      brokerageProvider.addingBrokerageProvider = true;
    },
    addedBrokerageProviderSuccess: (brokerageProvider, action) => {
      brokerageProvider.addedBrokerageProvider = true;
      brokerageProvider.brokerageCreateResp = action.payload;
    },
  },
});

export const {
  allBrokeragePaymentProviderSuccess,
  addedBrokerageProviderSuccess,
  addingBrokerageProviderInitialize,
} = slice.actions;

export default slice.reducer;

// action creator

export const allBrokeragePaymentProvider = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/payment-provider",
    method: "get",
    onSuccess: allBrokeragePaymentProviderSuccess.type,
  });

export const addBrokeragePaymentProvider = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/payment-provider",
    method: "post",
    data: data,
    onStart: addingBrokerageProviderInitialize.type,
    onSuccess: addedBrokerageProviderSuccess.type,
  });

// export const getDeleteCategory = (data) =>
//   apiCallBegan({
//     serviceUrl: process.env.REACT_APP_BASICSERVICE,
//     url: "/api/reminder-category",
//     method: "delete",
//     data: data,
//     onStart: categoryStartSuccess.type,
//     onSuccess: categoryDeletedSuccess.type,
//   });
// Selector
export const getBrokerageProviders = createSelector(
  (state) => state.entities.brokerageProvider,
  (brokerageProvider) => brokerageProvider.brokerageProviders
);
export const getBrokerageMessageResponse = createSelector(
  (state) => state.entities.brokerageProvider,
  (brokerageProvider) => brokerageProvider.brokerageCreateResp
);
export const isAddingBrokerage = createSelector(
  (state) => state.entities.brokerageProvider,
  (brokerageProvider) => brokerageProvider.isAddingBrokerage
);
export const isAddedProvider = createSelector(
  (state) => state.entities.brokerageProvider,
  (brokerageProvider) => brokerageProvider.addedBrokerageProvider
);
